module.exports = __webpack_public_path__ + "img/ifeanyi mako.fa1fbb2d.png";